//Modules
import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

//Components
import SearchPessoas from './SearchPessoas'
import SearchSite from './SearchSite'
import SearchNews from './SearchNews'
import SearchEvents from './SearchEvents'

function SearchForm({ inputRef }) {
    const [filtroPesquisa, setfiltroPesquisa] = useState("")
    const internalInputRef = useRef(null)
    const effectiveInputRef = inputRef || internalInputRef

    let history = useLocation()
    const lang = history.pathname.substring(1,3)

    useEffect(() => {
        const handleShown = () => {
            if (effectiveInputRef.current) {
                effectiveInputRef.current.focus()
            }
        }

        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
                e.preventDefault()
                const $ = window.$
                if ($ && $('#searchModal').length) {
                    $('#searchModal').modal('show')
                }
                if (effectiveInputRef.current) {
                    effectiveInputRef.current.focus()
                }
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        const modalElement = document.getElementById('searchModal')
        if (modalElement) {
            modalElement.addEventListener('shown.bs.modal', handleShown)
        }

        const $ = window.$
        if ($ && $('#searchModal').length) {
            $('#searchModal').on('shown.bs.modal', handleShown)
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown)
            if (modalElement) {
                modalElement.removeEventListener('shown.bs.modal', handleShown)
            }
            if ($ && $('#searchModal').length) {
                $('#searchModal').off('shown.bs.modal', handleShown)
            }
        }
    }, [effectiveInputRef])

    const makeSearch = debounce((e) => {
        setfiltroPesquisa(e.target.value)
    })

    function debounce(cb, delay=400) {
        let timeout

        return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() =>{
                cb(...args)
            }, delay)
        }
    }
    
    return (
        <>
            <div className="modal fade" id="searchModal" tabIndex="-1" aria-labelledby="searchModal" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='inputText'>
                                <label htmlFor="totalSearch" className="material-icons">search</label>
                                <input id='totalSearch' type='text' ref={effectiveInputRef} placeholder='Pesquisa unipb.pt' onFocus={(e)=>{console.log("focus")}} onChange={(e) => makeSearch(e)}></input>
                            </div>
                            <div className='searchRes'>  
                                {filtroPesquisa !== "" && <SearchPessoas filtroPesquisa={filtroPesquisa} />}
                                <SearchSite filtroPesquisa={filtroPesquisa} lang={lang} />
                                <SearchNews filtroPesquisa={filtroPesquisa} lang={lang} />
                                <SearchEvents filtroPesquisa={filtroPesquisa} lang={lang} />
                            </div>
                        </div>                
                    </div>
                </div>
            </div>          
        </>
    )
}

export default SearchForm
